<template>
  <div>
    <a-tabs v-model="activeKey">
      <a-tab-pane key="1" tab="1.場館設定">
        <venue-edit-form></venue-edit-form>
      </a-tab-pane>
      <a-tab-pane key="2" tab="2.座位分組">
        <set-group-seat-form></set-group-seat-form>
      </a-tab-pane>
      <a-tab-pane key="3" tab="3.人員信息">
        <person-list></person-list>
      </a-tab-pane>
      <a-tab-pane key="4" tab="4.分配座位">
        <seat-assign-form></seat-assign-form>
      </a-tab-pane>
      <template #tabBarExtraContent>
        <a-button @click="EditActivity()">活動編輯</a-button>
      </template>
    </a-tabs>
    <activity-modal ref="modalForm" @ok="modalFormOk"></activity-modal>
  </div>
</template>

<script>
import { httpAction, getAction } from '@/api/manageChooseSeat'
import '@/assets/less/TableExpand.less'
import { JeecgListMixin } from '@/views/chooseSeat/mixins/JeecgListMixin.js'
import PersonList from '../../Person/PersonList'
import SeatGroupList from '../../ActivityManage/SeatGroupList'
import SeatAssignForm from './SeatAssignForm'
import ActivityModal from './ActivityModal'
import SetGroupSeatForm from './SetGroupSeatForm'
import ViewSeatForm from './ViewSeatForm'
import VenueEditForm from '../../BaseData/Venue/modules/VenueEditForm'


export default {
  name: 'ActivitySetting',
  inject: ['operation', 'dataActivity'],
  components: {
    PersonList,
    SeatGroupList,
    SeatAssignForm,
    ActivityModal,
    SetGroupSeatForm,
    ViewSeatForm,
    VenueEditForm
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      model: {},
      uploadSource: "chooseseat",
      // form 一行布局
      labelCol1: { span: 4 },
      wrapperCol1: { span: 18 },
      // form 两行布局， 默认为两行
      labelCol2: { span: 8 },
      wrapperCol2: { span: 12 },
      confirmLoading: false,
      activeKey: '1',
      sysvenueid: '',
      sysactivityid: '',

    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    formDisabled() {
      return this.disabled
    },

  },
  created() {
  },
  mounted() {

  },
  watch: {
  },
  methods: {

    EditActivity() {
      let params={"sysactivityid":this.operation.activityinfo.sysactivityid};
      getAction("/ActivityInfo/list", params).then((res) => {
        if (res.success) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          const result = res.result.records || res.result
          this.operation.activityinfo=result[0];
      this.$refs.modalForm.edit(this.operation.activityinfo);
        }
      });
      this.$refs.modalForm.title = "编辑";
      this.$refs.modalForm.disableSubmit = false;
      this.operation.optiontype = "edit";
      this.operation.visible = true;
    }
  }
}

</script>
<style scoped>
.ant-modal-body {
  padding: 2px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
}
</style>